<div class="abha-card">
  <button *ngIf="!cardSource" mat-stroked-button color="primary" type="button" [disabled]="isLoading" (click)="onViewCard()">
    {{ (isLoading ? 'ABHA.CARD_LOADING' : 'ABHA.CARD_VIEW') | translate }}
  </button>

  <ng-container *ngIf="cardSource">
    <img *ngIf="isImage" class="abha-card-image" [src]="cardSource" [alt]="'ABHA.CARD_VIEW' | translate" />
    <a *ngIf="!autoDownload" mat-stroked-button color="primary" [href]="cardSource" [download]="fileName">
      {{ 'ABHA.CARD_DOWNLOAD' | translate }}
    </a>
  </ng-container>
</div>
